import { OutlinedInput } from '@aibees/shared/components';
import { useAdvanceTableContext } from '@aibees/shared/features/advance-table/context';
import { classnames } from '@aibees/shared/utils';
import { Box, Checkbox, ListItemIcon, ListItemText } from '@mui/material';
import React, { ChangeEvent, memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { RowSelectorPopupMaxPeopleProps as Props } from './types';

export const RowSelectionPopupMaxPeople = memo(
  ({
    className,
    inputRef,
    maxPeople,
    onMaxPeopleChange,
    onMaxPeopleCheckedChange,
  }: Props) => {
    const { table } = useAdvanceTableContext();

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onMaxPeopleChange?.(e.target.value);
    };
    const onChecked = (e: ChangeEvent<HTMLInputElement>) => {
      table?.selection.onSetExtraParam('maxPeopleChecked', e.target.checked);
      onMaxPeopleCheckedChange?.(e.target.checked);
    };

    return (
      <Box display="flex" flexDirection="column">
        <Styled.Wrapper
          className={classnames('RowSelectionPopupMaxPeople', className)}
          sx={SX.root}
        >
          <ListItemIcon>
            <Checkbox
              size="small"
              checked={!!table?.selection.extraParam?.maxPeopleChecked}
              name=""
              sx={SX.checkbox}
              onChange={onChecked}
            />
          </ListItemIcon>

          <ListItemText sx={SX.text}>Max. People Per Company</ListItemText>

          <Styled.ContentRow>
            <OutlinedInput
              type="number"
              autoComplete="off"
              size="xsmall"
              onClick={(e) => e.stopPropagation()}
              inputRef={inputRef}
              onChange={onChange}
              disabled={!table?.selection.extraParam?.maxPeopleChecked}
              inputProps={{ min: 0, max: 10000 }}
              value={maxPeople}
              sx={SX.input}
            />
          </Styled.ContentRow>
        </Styled.Wrapper>
      </Box>
    );
  }
);

RowSelectionPopupMaxPeople.displayName = 'RowSelectionPopupMaxPeople';
